import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import { Suspense } from "react";
import type { QueryClient } from "@tanstack/react-query";
import { ToastProvider } from "../components/ui/Toast";

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: RootComponent,
});

function RootComponent() {
  return (
    <ToastProvider>
      <Outlet />
      <Suspense fallback={null}>
        {import.meta.env.DEV ? <TanStackRouterDevtools position="bottom-right" /> : null}
      </Suspense>
    </ToastProvider>
  );
}
